/**
 * The "Nachname, Vorname" text of a person (Employee, User).
 *
 * A tenant may keep only first names, and a last name is not forced
 * (ticket AaDUz8N0cLqoz6BVG58uCQ), so only the non-blank parts are joined:
 * a missing part takes its comma and space with it. Both parts empty gives
 * `''`, which callers can treat as "no name".
 */
export function formatPersonName(lastName: string, firstName: string): string {
    return [lastName, firstName]
        .map(part => (part ?? '').trim())
        .filter(part => part !== '')
        .join(', ');
}
